import React from 'react';

import cx from 'classnames';
import TextAreaAutosize from 'react-textarea-autosize';

import ValidationMessage from '../../../../general/ValidationMessage';
import styleMap from '../../styleMap';

import styles from './LongTextInputBlock.scss';

/**
 * @deprecated since 5.8.10, use the PropertyInputBlock instead.
 */
function LongTextInputBlock({
  text,
  maxLength = 2048,
  placeholder = 'Enter text…',
  disabled = false,
  onInput = () => {},
  isValid = true,
  validationMessage = 'Required.',
  className,
  style,
}: any) {
  return (
    <div className={styles.LongTextInputBlock}>
      <TextAreaAutosize
        value={text || ''}
        maxLength={maxLength}
        className={cx(styles.input, className)}
        style={styleMap(false, style)}
        placeholder={placeholder}
        disabled={disabled}
        minRows={3}
        onChange={e => onInput(e.target.value)}
      />

      {!isValid && <ValidationMessage errors={[validationMessage]} />}
      <div className={styles.wrapper} />
    </div>
  );
}

export default LongTextInputBlock;
